import { useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  FileText,
  TrendingUp,
  Link2,
  Clock,
  Calendar,
  BarChart3,
  ClipboardList,
  LayoutGrid,
  Settings,
} from 'lucide-react';

export const navItems = [
  { icon: LayoutGrid, label: 'Início', to: '/simples-nacional', exact: true },
  {
    icon: FileText,
    label: 'Gestão de Documentos Fiscais',
    to: '/simples-nacional/gestao-documentos',
    exact: false,
  },
  { icon: TrendingUp, label: 'Apuração', to: '/simples-nacional/apuracao', exact: false },
  { icon: Link2, label: 'Integrações', to: '/simples-nacional/integracoes', exact: false },
  { icon: Clock, label: 'Histórico', to: '/simples-nacional/historico', exact: false },
  { icon: Calendar, label: 'Obrigações', to: '/simples-nacional/obrigacoes', exact: false },
  { icon: BarChart3, label: 'Relatórios', to: '/simples-nacional/relatorios', exact: false },
  { icon: ClipboardList, label: 'Central', to: '/simples-nacional/central', exact: false },
  { icon: Settings, label: 'Configurações', to: '/simples-nacional/configuracoes', exact: false },
];

export function isActive(pathname: string, to: string, exact: boolean): boolean {
  return exact ? pathname === to : pathname.startsWith(to);
}

export function useSimplesNacionalLayout() {
  const { pathname } = useLocation();
  const [pinned, setPinned] = useState(false);
  const [hovered, setHovered] = useState(false);
  const hoverLeaveTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const expanded = pinned || hovered;

  function handleMouseEnter() {
    if (pinned) return;
    if (hoverLeaveTimer.current) clearTimeout(hoverLeaveTimer.current);
    setHovered(true);
  }

  function handleMouseLeave() {
    if (pinned) return;
    hoverLeaveTimer.current = setTimeout(() => setHovered(false), 120);
  }

  return {
    pathname,
    navItems,
    isActive,
    pinned,
    setPinned,
    hovered,
    expanded,
    handleMouseEnter,
    handleMouseLeave,
  };
}
